import { render, staticRenderFns } from "./PaymentVerify.vue?vue&type=template&id=61dbd054&scoped=true&"
import script from "./PaymentVerify.vue?vue&type=script&lang=js&"
export * from "./PaymentVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dbd054",
  null
  
)

export default component.exports